"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotHospital = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotHospital = _ref => {
  let {
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#Spot=on,_Size=40_svg__a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M34.4 39.076c-6.746 2.775-12.172-1.247-18.456-4.857C9.534 30.002-.79 31.317.048 22.86c.665-6.725 8.407-7.027 14.496-11.029C20.6 7.835 23.221 5.904 28.44 7.638c5.183 1.739 10.16 5.108 11.292 11.247 1.098 6.143-1.28 17.657-5.332 20.19Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M29.571 22.2h3.434a2.71 2.71 0 0 1 2.709 2.707v9.887c0 .509-.413.92-.922.92h-5.22m0-13.513V7.957a3.677 3.677 0 0 0-3.674-3.67H14.102a3.677 3.677 0 0 0-3.674 3.67v9.963M29.57 22.2v13.515M10.428 17.92h-3.68c-1.312 0-2.463 1.265-2.463 2.707v14.167c0 .509.413.92.922.92h5.22m0-17.794v17.795m0 0H17.1m12.472 0h-6.67m-5.802 0H22.9m-5.801 0v-8.53H22.9v8.53M20 12.509v-2.14m0 0v-2.14m0 2.14h-2.141m2.14 0h2.14m-7.854 6.06h2.857M14.285 22h2.857m5.715-5.571h2.857M22.857 22h2.857"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "Spot=on,_Size=40_svg__a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};
exports.SpotHospital = SpotHospital;
SpotHospital.displayName = "SpotHospital";